module.exports = __webpack_public_path__ + "static/img/s08.1e6136b8.png";